import { fallback } from '@tanstack/zod-adapter';
import { z } from 'zod';

// Navigation instruction, never a URL state: a navigate/redirect that sets
// this value has the param normalized away by the schema below. This is the
// only way a thrown redirect can remove a retained search param -- the
// sentinel must survive inside the redirect's href, so a middleware cannot
// consume it (see ADR 012).
export const STRIP_COUPON = 'internal__strip_coupon';

export const oppCouponSearchSchema = z.object({
  ssu_coupon: fallback(
    z.coerce
      .string()
      .optional()
      .transform(value => (value === STRIP_COUPON ? undefined : value)),
    undefined,
  ),
});
